export const callDataLayer = (data, callback) => {
  window.dataLayer = window.dataLayer || [];
  try {
    data.eventCallback = callback || (() => {});
    window.dataLayer.push(data);
  } catch (err) {
    console.log("GTM not found");
  }
};